import loadFonts from './webfontloader';

// eslint-disable-next-line no-unused-vars
const registerPlugins = (app) => {
  // noinspection JSIgnoredPromiseFromCall
  loadFonts();
};

export default registerPlugins;
